import { Controller } from "@hotwired/stimulus"

// Lie une checkbox enfant à une checkbox parente : le bloc enfant n'est visible
// que si le parent est coché, et l'enfant est décoché dès que le parent l'est
// (règle métier « enfant impossible sans parent », ex. featured ⇒ homepage_visible).
// L'état initial est posé au connect() pour refléter la valeur serveur à
// l'ouverture du formulaire (édition d'un cours déjà masqué).
//
// Câblage (voir courses/_form.html.erb) :
//   data-controller="dependent-checkbox"
//   data-action="change->dependent-checkbox#sync"
//   data-dependent-checkbox-target="parent" sur le wrapper de la checkbox parente
//   data-dependent-checkbox-target="child"  sur le wrapper de la checkbox enfant
export default class extends Controller {
  static targets = ["parent", "child"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasParentTarget || !this.hasChildTarget) return

    const parentCheckbox = this.parentCheckbox
    if (!parentCheckbox) return // structure inattendue : ne rien masquer silencieusement

    const parentChecked = parentCheckbox.checked
    this.childTarget.classList.toggle("hidden", !parentChecked)

    if (!parentChecked && this.childCheckbox) {
      this.childCheckbox.checked = false
    }
  }

  get parentCheckbox() {
    return this.parentTarget.querySelector("input[type='checkbox']")
  }

  get childCheckbox() {
    return this.childTarget.querySelector("input[type='checkbox']")
  }
}
